<template>
    <div id="app" class="fillcontain"> 
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'App',
    data: function() {
        return {}
    }
}

</script>



// WEBPACK FOOTER //
// src/App.vue